import { RootState } from "store";
import { IDetailsRightResponse } from "types/roles-and-rights.interface";

export const getRightDetailsSelector = (state: RootState): IDetailsRightResponse | null => state.rightDetails.rightDetails;
export const getRoleDetailsUpdateSuccess = (state: RootState): boolean | null => Boolean(state.roleDetails.update?.success);

